<script setup>
import Feedback from '@/Pages/Partials/Nr-Feedback.vue';

</script>

<template>
    <v-layout class="rounded rounded-md">
        <v-app-bar
            flat
            color="text"
            class="main-header d-flex justify-center mb-0 pb-0"
            height="177px"
        >
            <img
                src="/static/images/ApplicationLogo.png"
                alt="Application Logo"
                height="129px"
                class="mx-auto py-6"
            />
        </v-app-bar>

        <v-main
            class="guest-main main-content-block text-text"
            style="min-height: 785px"
        >
            <v-row>
                <v-col cols="12">
                    <slot name="noGutter"></slot>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col
                    cols="10"
                    class="d-flex justify-center"
                >
                    <Feedback></Feedback>
                    <slot />
                </v-col>
            </v-row>
        </v-main>
    </v-layout>
</template>

<style scoped>
.main-header {
  border-bottom: 5px rgb(var(--v-theme-white)) solid;
}

.guest-main {
  background-color: rgb(var(--v-theme-white)) !important;
}

.main-content-block {
  margin-top: 134px !important;
  padding-top: 0px !important;
  border-bottom: 5px rgb(var(--v-theme-primary)) solid;
}
</style>

<style>
body {
  background: rgb(var(--v-theme-text)) !important;
}
</style>
